<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>

<!-- Food Menu Dishes Starts -->
<div *ngIf="showFoodMenu">
  <div class="container-fluid">
    <div class=" d-flex" style="margin-top: 7%;padding-left: 13px; align-items: center;">
      <div class="">
        <img src="../../../../assets/img/backMenu.svg" alt="" style="cursor:pointer" (click)="backHome()"
          style="cursor: pointer;">
      </div>
      <div style="display: flex;flex: 1; justify-content: space-between; align-items: center; padding-right: 10px;" [ngClass]="{'forcedClass': !isL0Resto}" >
        <div class="restoName">
          <img [src]="restoLogo" alt="" alt="logo" style="width: 30px;margin-right: 10px;" *ngIf="restoLogo != null">
          {{restoName}}
        </div>
        <button type="button" class="btn btn-outline-info allergen_info_btn" *ngIf="!isL0Resto" style="margin-left: 30px;" (click)="addOwnMenu()">Get Your Own Menu</button>
        <!-- <button type="button" class="btn btn-outline-info allergen_info_btn" *ngIf="allergensarry.length > 0 && allergenMsg" (click)="showAllergenDialog()">Allergen
          Info</button> -->
      </div>

      <div class="restoDescription "></div>
    </div>
    <div *ngIf="restoBranchFlag">
      <div class="branchBtn-main-div">
        <button *ngFor="let item of restoBranchData" (click)="changeResto(item.restaurant_id)" class="branchChangeBtn"
          [ngClass]="restoBranchCurrentId==item.restaurant_id?'branchActiveCss':''">{{item.label}}</button>
      </div>
    </div>
  </div>


  <div class="dish_list_bottom">
    <div class="container-fluid" style="position: sticky;top: 0;z-index: 11;">
      <div class="searchbg">
        <div class="form-group d-flex">
          <div class="searchbar mt-3">
            <i class="fa fa-search"></i><span class="search-next">|</span>
            <input type="text" class="textvalue ml-2" placeholder="Search for dishes available ..." [(ngModel)]="query"
              (input)="valuechange($event.target.value)" />
          </div>
          <div style="margin-top: 20px;margin-left:15px;cursor: pointer;">
            <!-- <img src="../../../../assets/img/imagescreenpre.png" alt="" (click)="showPreference()"> -->
            <img src="../../../../assets/img/imagescreenpre.png" alt="" (click)="showPreferences()">
          </div>
        </div>
      </div>

      <div *ngIf="!isDefaultMenuLabel">
        <div class="menu_label_main_div">
          <ng-container *ngFor="let label of menuLabel">
            <div class="menu_label_sub_div" [ngClass]="{'active_menu_label_sub_div': selectedMenuLabelId == label.id}" (click)="changeManuLabel(label)">{{label.dish_menu_name}}</div>
          </ng-container>
        </div>
        
      </div>
    </div>
    <div *ngIf="sortedDispalyFlag">
      <div id="id_{{item.key}}" *ngFor="let item of newItems | keyvalue| filter: query;let i = index">
        <div class="container-fluid">
          <div class="catNames">
            <span>{{item.key}}</span>
            <button (click)="openAllergenChartDilog(item)" class="allergen_chart_btn">
              <span>Allergens chart </span>
              <img src="../../../../assets/img/allergens_chart_icon.svg" alt="">
            </button>
          </div>

        </div>

        <div>
          <div *ngFor="let value of item.value | filter: query;let i = index">
            <div class="container" style="padding-left: 20px !important; ">
              <div class="d-flex">
                <div class="subNameCointainer" style="width:75%;margin-top: -15px;">
                  <div class="mt-4">

                    <div *ngIf="value.topChoice == 'Yes' && value.canEat != 'No' && value.dpAvailable != 'No'"
                      class="rankedUp">
                      <div class="tooltip">
                        Ranked Up
                        <img src="../../../../assets/img/ranked-up.svg" alt="" style="cursor: pointer;" width="20">
                        <span class="tooltiptext tooltipRankUp"><span>This dish is ranked up as it contains some
                            ingredients that you like</span></span>
                      </div>
                    </div>
                    <div class="headers ">
                      <div>
                        <span style="cursor: pointer;" (click)="openMediaFunc(value.name,value.id)">{{value.name}}</span>
                        <div *ngIf="value.canEat == 'No' || value.dpAvailable == 'No';else checkOption"
                          style="position: relative; display: inline-block !important;"
                          (click)="unsuitableAllergen(value.id,value.name)">
                          <div class="tooltip">
                            <img src="/assets/img/unsuitable-dietary-prefernces.svg" alt=""
                              style="cursor: pointer; min-width: 20px; padding-bottom: 5px; margin-left: 4px;"
                              width="20">
                            <span class="tooltiptext">This dish is not suitable</span>
                          </div>
                        </div>
                        <ng-template #checkOption>
                          <div *ngIf="value.canEat == 'Yes' || value.dpAvailable == 'Yes'"
                            style="position: relative; display: inline-block !important;"
                            (click)="unsuitableAllergen(value.id,value.name)">
                            <div class="tooltip">
                              <img src="../../../../assets/img/unsuitable-dietary-prefernces-orange.svg" alt=""
                                style="cursor: pointer; min-width: 20px;padding-bottom: 5px; margin-left: 4px;"
                                width="20">
                              <span class="tooltiptext">This dish may have option for you</span>
                            </div>
                          </div>
                        </ng-template>
                      </div>

                    </div>
                  </div>
                  <div class="price" *ngIf="value.dish_option.length == 0">
                    <span>
                      &#163; {{value.price}}
                    </span>
                  </div>
                  <div class="price" *ngIf="value.dish_option.length > 0">
                    <div style="width: max-content;">
                      <div *ngFor="let dishItem of value.dish_option" class="dishOption">
                        <div>{{dishItem.option_name}}</div>
                        <div class="dishPrice">:<span>&#163; </span> {{dishItem.option_price}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="textpara" style="cursor: pointer;" (click)="openDescriptionFunc(value.name,value.id)">
                    {{value.description}}
                  </div>

                  <div class="">
                    <div *ngIf="value.overallRating == 'NA'" class="Na-star-rating"
                      (click)="goToRatingsBottomSheet(value.name,value.id)">
                      <img src="../../../../assets/img/white-star.svg" alt=""><span class="rating-text-new">0</span>
                    </div>

                    <div *ngIf="value.overallRating != 'NA'" class="Na-star-rating"
                      (click)="goToRatingsBottomSheet(value.name,value.id)">
                      <img src="../../../../assets/img/start-icon.svg" alt=""><span
                        class="rating-text-new">{{value.overallRating}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- *ngIf="!(conditionToDisaply && getQuantity(value.id)>0)" -->
                  <div class="d-flex">
                    <div>
                      <!-- <button class="add-btnnew"
                        (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">ADD <span
                          class="right-bar" *ngIf="getQuantity(value.id)>0">&nbsp;</span> <span
                          class="quantity-counter">{{getQuantity(value.id)}}</span> </button> -->
                      <button class="add-btnnew" *ngIf="getQuantity(value.id)== null"
                        (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">ADD <span
                          class="right-bar">&nbsp;</span> <span
                          class="quantity-counter">{{getQuantity(value.id)}}</span>
                      </button>


                      <!-- <div class="wrapper" *ngIf="getQuantity(value.id)>0">
                        <button class="plusminus-left" *ngIf="(conditionToDisaply &&getQuantity(value.id)>0)"
                          (click)="removeFromCart(value.id)">-</button>
                        <label class="addmenu" *ngIf="getQuantity(value.id)>0">{{getQuantity(value.id)}}</label>
                        <button class="plusminus"
                          (click)="addToCart(i, value.id, value.name, value.price, value.price);addToCartDone(i,getQuantity(value.id),value.id)">+</button>
                      </div> -->
                      <div class="wrapper" *ngIf="getQuantity(value.id)>0">
                        <button class="plusminus-left" *ngIf="(conditionToDisaply &&getQuantity(value.id)>0)"
                          (click)="removeMinusFunc(value.id, i)">-</button>
                        <label class="addmenu" *ngIf="getQuantity(value.id)>0"
                          id="{{'countQuantity'+ i}}">{{getQuanNumber(value.id)}}</label>
                        <button class="plusminus" (click)="addBtnFunc(value.id, i)">+</button>
                      </div>



                    </div>

                    <!-- <div>
                      <div class="btn-group" >
                        <button class="btn-ad" (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">ADD</button>
                        <button class="btn-ad2" *ngIf="getQuantity(value.id) > 1 ">{{getQuantity(value.id)}}</button>
                      </div>
                    </div> -->


                    <button class="info-icon-svg" (click)="goToDishDetails(value.name,value.id)"><img
                        style="min-height: 25px;" src="../../../../assets/img/info.svg" alt=""></button>
                  </div>
                  <div *ngIf="value.addOnExists" class="customise-text">Customisable</div>

                  <div class="allergens_btn_main_div" (click)="openAllegenList(value.id)"
                    *ngIf="value.dish_allergens.length > 0">
                    <span>Allergens</span>
                    <img src="../../../../assets/img/dropdwon_icon_red.svg" alt="">
                  </div>

                  <!-- <div *ngIf="(conditionToDisaply && getQuantity(value.id)>0)" class="d-flex">
                    <button class="added-btnnew">Added</button>
                    <button class="info-icon-svg" (click)="goToDishDetails(value.name,value.id)"><img
                        src="../../../../assets/img/info.svg" alt=""></button>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="container-fluid" style="border-bottom: 1px solid #ebebeb;">
              &nbsp;
            </div>

          </div>

        </div>
        <!-- <div class="container-fluid" style="padding-left: 20px !important; ">
          <div class="item" *ngFor="let value of item.value | filter: query;let i = index">
            <div class="d-flex" style="border-bottom: 1px solid #ebebeb;padding-bottom: 5px;">
              <div style="width:70%;margin-top: -15px;">
                <div class="mt-4">
                  <div *ngIf="value.topChoice == 'Yes'" class="rankedUp">Ranked Up <span><img
                        src="../../../../assets/img/ranked-up.svg" alt=""></span></div>
                  <div class="headers ">
                    {{value.name}}
                  </div>
                </div>
                <div class="price">
                  <span>
                    &#163; {{value.price}}
                  </span>
                </div>
  
                <div class="textpara">
                  {{value.description}}
                </div>
  
                <div class="">
                  <div *ngIf="value.overallRating == 'NA'" class="Na-star-rating"
                    (click)="goToRatingsBottomSheet(value.name,value.id)">
                    <img src="../../../../assets/img/unfilled-star.svg" alt=""><span class="rating-text-new">0</span> 
                  </div>
  
                  <div *ngIf="value.overallRating != 'NA'" class="Na-star-rating"
                    (click)="goToRatingsBottomSheet(value.name,value.id)"> 
                    <img src="../../../../assets/img/start-icon.svg" alt=""><span class="rating-text-new">{{value.overallRating}}</span> 
                  </div>
                </div>
              </div>
              <div>
                <div *ngIf="!(conditionToDisaply && getQuantity(value.id)>0)">
                  <button class="add-btnnew"
                    (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">Add</button>
                </div>
                <div *ngIf="value.addOnExists" class="customise-text">Customisable</div>
                <div *ngIf="value.canEat == 'No'" class="d-flex justify-content-end" style="margin-top: 3px;">
                  <button type="button" placement="bottom" class="btn-select"
                    ngbTooltip="This is unsuitable as per your dietary preferences"><img
                      src="../../../../assets/img/unsuitable-dietary-prefernces.svg" alt=""></button>
                </div>
                <div *ngIf="(conditionToDisaply && getQuantity(value.id)>0)">
                  <button class="added-btnnew">Added</button>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div *ngIf="!sortedDispalyFlag">
      <div id="id_{{item.key}}" *ngFor="let item of newItems | keyvalue:asIsOrder| filter: query;let i = index">
        <div class="container-fluid">
          <div class="catNames">
            <span>{{item.key}}</span>
            <button (click)="openAllergenChartDilog(item)" class="allergen_chart_btn">
              <span>Allergens chart </span>
              <img src="../../../../assets/img/allergens_chart_icon.svg" alt="">
            </button>
          </div>
        </div>

        <div>
          <div *ngFor="let value of item.value | filter: query;let i = index">
            <div class="container" style="padding-left: 20px !important; ">
              <div class="d-flex">
                <div class="subNameCointainer" style="width:75%;margin-top: -15px;">
                  <div class="mt-4">
                    <div *ngIf="value.topChoice == 'Yes'" class="rankedUp">Ranked Up <span><img
                          src="../../../../assets/img/ranked-up.svg" alt=""></span></div>
                          <div class="headers ">
                            <div>
                              <span style="cursor: pointer;" (click)="openMediaFunc(value.name,value.id)">{{value.name}}</span>
                              <div *ngIf="value.canEat == 'No' || value.dpAvailable == 'No';else checkOption"
                                style="position: relative; display: inline-block !important;"
                                (click)="unsuitableAllergen(value.id,value.name)">
                                <div class="tooltip">
                                  <img src="/assets/img/unsuitable-dietary-prefernces.svg" alt=""
                                    style="cursor: pointer; min-width: 20px; padding-bottom: 5px; margin-left: 4px;"
                                    width="20">
                                  <span class="tooltiptext">This dish is not suitable</span>
                                </div>
                              </div>
                              <ng-template #checkOption>
                                <div *ngIf="value.canEat == 'Yes' || value.dpAvailable == 'Yes'"
                                  style="position: relative; display: inline-block !important;"
                                  (click)="unsuitableAllergen(value.id,value.name)">
                                  <div class="tooltip">
                                    <img src="../../../../assets/img/unsuitable-dietary-prefernces-orange.svg" alt=""
                                      style="cursor: pointer; min-width: 20px;padding-bottom: 5px; margin-left: 4px;"
                                      width="20">
                                    <span class="tooltiptext">This dish may have option for you</span>
                                  </div>
                                </div>
                              </ng-template>
                            </div>
      
                          </div>
                  </div>
                  <div class="price" *ngIf="value.dish_option.length == 0">
                    <span>
                      &#163; {{value.price}}
                    </span>
                  </div>
                  <div class="price" *ngIf="value.dish_option.length > 0">
                    <div style="width: max-content;">
                      <div *ngFor="let dishItem of value.dish_option" class="dishOption">
                        <div>{{dishItem.option_name}}</div>
                        <div class="dishPrice">:<span>&#163; </span> {{dishItem.option_price}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="textpara" style="cursor: pointer;" (click)="openDescriptionFunc(value.name,value.id)">
                    {{value.description}}
                  </div>

                  <div class="">
                    <div *ngIf="value.overallRating == 'NA'" class="Na-star-rating"
                      (click)="goToRatingsBottomSheet(value.name,value.id)">
                      <img src="../../../../assets/img/white-star.svg" alt=""><span class="rating-text-new">0</span>
                    </div>

                    <div *ngIf="value.overallRating != 'NA'" class="Na-star-rating"
                      (click)="goToRatingsBottomSheet(value.name,value.id)">
                      <img src="../../../../assets/img/start-icon.svg" alt=""><span
                        class="rating-text-new">{{value.overallRating}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <!-- *ngIf="!(conditionToDisaply && getQuantity(value.id)>0)" -->
                  <div class="d-flex">
                    <div>
                      <!-- <button class="add-btnnew"
                        (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">ADD <span
                          class="right-bar" *ngIf="getQuantity(value.id)>0">&nbsp;</span> <span
                          class="quantity-counter">{{getQuantity(value.id)}}</span> </button> -->
                      <button class="add-btnnew" *ngIf="getQuantity(value.id)== null"
                        (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">ADD <span
                          class="right-bar">&nbsp;</span> <span
                          class="quantity-counter">{{getQuantity(value.id)}}</span>
                      </button>


                      <!-- <div class="wrapper" *ngIf="getQuantity(value.id)>0">
                        <button class="plusminus-left" *ngIf="(conditionToDisaply &&getQuantity(value.id)>0)"
                          (click)="removeFromCart(value.id)">-</button>
                        <label class="addmenu" *ngIf="getQuantity(value.id)>0">{{getQuantity(value.id)}}</label>
                        <button class="plusminus"
                          (click)="addToCart(i, value.id, value.name, value.price, value.price);addToCartDone(i,getQuantity(value.id),value.id)">+</button>
                      </div> -->
                      <div class="wrapper" *ngIf="getQuantity(value.id)>0">
                        <button class="plusminus-left" *ngIf="(conditionToDisaply &&getQuantity(value.id)>0)"
                          (click)="removeMinusFunc(value.id, i)">-</button>
                        <label class="addmenu" *ngIf="getQuantity(value.id)>0"
                          id="{{'countQuantity'+ i}}">{{getQuanNumber(value.id)}}</label>
                        <button class="plusminus" (click)="addBtnFunc(value.id, i)">+</button>
                      </div>



                    </div>

                    <!-- <div>
                      <div class="btn-group" >
                        <button class="btn-ad" (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">ADD</button>
                        <button class="btn-ad2" *ngIf="getQuantity(value.id) > 1 ">{{getQuantity(value.id)}}</button>
                      </div>
                    </div> -->


                    <button class="info-icon-svg" (click)="goToDishDetails(value.name,value.id)"><img
                        style="min-height: 25px;" src="../../../../assets/img/info.svg" alt=""></button>
                  </div>
                  <div *ngIf="value.addOnExists" class="customise-text">Customisable</div>
                  <div class="allergens_btn_main_div" (click)="openAllegenList(value.id)"
                    *ngIf="value.dish_allergens.length > 0">
                    <span>Allergens</span>
                    <img src="../../../../assets/img/dropdwon_icon_red.svg" alt="">
                  </div>
                  <!-- <div *ngIf="value.canEat == 'No'" class="d-flex justify-content-end"
                    style="margin-top: 3px;margin-right: 15px;">
                    <div class="tooltip">
                      <img src="/assets/img/unsuitable-dietary-prefernces.svg" alt="" style="cursor: pointer;"
                        width="20">
                      <span class="tooltiptext">This is unsuitable as per your dietary preferences</span>
                    </div>
                  </div> -->

                  <!-- <div *ngIf="(conditionToDisaply && getQuantity(value.id)>0)" class="d-flex">
                    <button class="added-btnnew">Added</button>
                    <button class="info-icon-svg" (click)="goToDishDetails(value.name,value.id)"><img
                        src="../../../../assets/img/info.svg" alt=""></button>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="container-fluid" style="border-bottom: 1px solid #ebebeb;">
              &nbsp;
            </div>

          </div>

        </div>
        <!-- <div class="container-fluid" style="padding-left: 20px !important; ">
          <div class="item" *ngFor="let value of item.value | filter: query;let i = index">
            <div class="d-flex" style="border-bottom: 1px solid #ebebeb;padding-bottom: 5px;">
              <div style="width:70%;margin-top: -15px;">
                <div class="mt-4">
                  <div *ngIf="value.topChoice == 'Yes'" class="rankedUp">Ranked Up <span><img
                        src="../../../../assets/img/ranked-up.svg" alt=""></span></div>
                  <div class="headers ">
                    {{value.name}}
                  </div>
                </div>
                <div class="price">
                  <span>
                    &#163; {{value.price}}
                  </span>
                </div>
  
                <div class="textpara">
                  {{value.description}}
                </div>
  
                <div class="">
                  <div *ngIf="value.overallRating == 'NA'" class="Na-star-rating"
                    (click)="goToRatingsBottomSheet(value.name,value.id)">
                    <img src="../../../../assets/img/unfilled-star.svg" alt=""><span class="rating-text-new">0</span> 
                  </div>
  
                  <div *ngIf="value.overallRating != 'NA'" class="Na-star-rating"
                    (click)="goToRatingsBottomSheet(value.name,value.id)"> 
                    <img src="../../../../assets/img/start-icon.svg" alt=""><span class="rating-text-new">{{value.overallRating}}</span> 
                  </div>
                </div>
              </div>
              <div>
                <div *ngIf="!(conditionToDisaply && getQuantity(value.id)>0)">
                  <button class="add-btnnew"
                    (click)="checkAddon(i,value);addToCartDone(i,getQuantity(value.id),value.id)">Add</button>
                </div>
                <div *ngIf="value.addOnExists" class="customise-text">Customisable</div>
                <div *ngIf="value.canEat == 'No'" class="d-flex justify-content-end" style="margin-top: 3px;">
                  <button type="button" placement="bottom" class="btn-select"
                    ngbTooltip="This is unsuitable as per your dietary preferences"><img
                      src="../../../../assets/img/unsuitable-dietary-prefernces.svg" alt=""></button>
                </div>
                <div *ngIf="(conditionToDisaply && getQuantity(value.id)>0)">
                  <button class="added-btnnew">Added</button>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="container">
      <div class="bottom_nav">
        <div class=" alertstick_menu">

        </div>
      </div>
    </div>

    <div class="container d-flex justify-content-end">
      <img src="./assets/img/Group 1361.svg" class="menu-img" alt="menu" width="80" (click)="menuClick()">
    </div>
  </div>
</div>

<div *ngIf="showErrorimg" class="container-fluid">
  <div class="d-flex justify-content-center" *ngIf="(showndata | filter:query).length == 0">
    <img src="assets/img/nodishFound.svg">
  </div>
  <div>
    <div class="d-flex justify-content-center nodishtext" *ngIf="(showndata | filter:query).length == 0">No Dishes Found
    </div>
  </div>
</div>



<div class="container-fluid">
  <div class="d-flex justify-content-between">
    <div *ngIf="UserCondition">
      <ul class=" nav nav-pills d-flex justify-content-between">
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'food-menu']" routerLinkActive="active" class="nav-link" #rla="routerLinkActive">
            <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />
            <span class="nav__text">Menu</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'order-menu']" routerLinkActive="active" class="nav-link"
            #rlas="routerLinkActive"><span class="lengthsSpan" *ngIf="lengths > 0">{{lengths}}</span>
            <img [src]="rlas.isActive ? iconcart : iconAtvcart" alt="">
            <span class="nav__text">Cart</span>
          </a>
        </li>

        <li class="nav-item col-xs-3">
          <a [routerLink]="['../',  'myOrders']" routerLinkActive="active" class="nav-link" #rlag="routerLinkActive">
            <img [src]="rlag.isActive ? iconorder : iconAtvorder" alt="">

            <span class="nav__text">Orders</span>
          </a>
        </li>

        <li class="nav-item col-xs-3 py-1">
          <a [routerLink]="['../', 'profile']" routerLinkActive="active" class="nav-link" #rlap="routerLinkActive">
            <img [src]="rlap.isActive  ? iconprofile : iconAtvprofile " alt="">
            <span class="nav__text">Profile</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div *ngIf="!UserCondition">
      <ul class=" nav nav-pills d-flex justify-content-between">
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'food-menu-guest']" routerLinkActive="active" class="nav-link"
            #rla="routerLinkActive">
            <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />
            <span class="nav__text">Menu</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a (click)="getLoginScreen()" routerLinkActive="active" class="nav-link" #rlas="routerLinkActive"><span
              class="lengthsSpan" *ngIf="lengths > 0">{{lengths}}</span>
            <img [src]="rlas.isActive ? iconcart : iconAtvcart" alt="">
            <span class="nav__text">Cart</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a (click)="getLoginScreen()" routerLinkActive="active" class="nav-link" #rlag="routerLinkActive">
            <img [src]="rlag.isActive ? iconorder : iconAtvorder" alt="">

            <span class="nav__text">Orders</span>
          </a>
        </li>
        <li class="nav-item col-xs-3 py-1">
          <a (click)="getLoginScreen()" routerLinkActive="active" class="nav-link" #rlap="routerLinkActive">
            <img [src]="rlap.isActive  ? iconprofile : iconAtvprofile " alt="">
            <span class="nav__text">Profile</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
















<div *ngIf="showmenus">

  <div class="bottom_nav">
    <div class="row alertstick_menu">
      <img src="./assets/img/Group 1361.svg" alt="menu" width="80" (click)="menuClick()">
    </div>
    <div class="row">
      <div *ngIf="UserCondition" class="footernav h-100 py-2">
        <ul class="nav nav-pills row">
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../', 'food-menu']" routerLinkActive="active" class="nav-link ">
              <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="24"></tc-icon>
              <span class="nav__text">Menu</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a (click)="passDataToService()" class="nav-link">
              <tc-icon [iconClass]="'icofont-shopping-cart'" [tcFontSize]="25"></tc-icon>
              <span class="nav__text">Cart</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../',  'order-list']" routerLinkActive="active" class="nav-link">
              <tc-icon [iconClass]="'icofont-food-basket'" [tcFontSize]="26"></tc-icon>
              <span class="nav__text">Orders</span>
            </a>
          </li>&nbsp;&nbsp;
          <li class="nav-item col-xs-3 py-1">
            <a [routerLink]="['../', 'profile']" routerLinkActive="active" class="nav-link">
              <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="22"></tc-icon>
              <span class="nav__text">Profile</span>
            </a>
          </li>
        </ul>
      </div>
      <div *ngIf="!UserCondition">
        <ul class="nav nav-pills row">
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../', 'food-menu-guest']" routerLinkActive="active" class="nav-link"
              #rla="routerLinkActive">
              <!-- <tc-icon [iconClass]="'icofont-restaurant-menu'" [tcFontSize]="24"></tc-icon> -->
              <!-- <img src="./assets/img/menu.svg" alt=""> -->
              <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />

              <span class="nav__text">Menu</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a (click)="passDataToService()" class="nav-link">
              <img src="./assets/img/cart.svg" alt="">
              <!-- <tc-icon [iconClass]="'icofont-shopping-cart'" [tcFontSize]="25"></tc-icon> -->
              <span class="nav__text">Cart</span>
            </a>
          </li>
          <li class="nav-item col-xs-3">
            <a [routerLink]="['../',  'order-list']" routerLinkActive="active" class="nav-link">
              <img src="./assets/img/order.svg" alt="">
              <!-- <tc-icon [iconClass]="'icofont-food-basket'" [tcFontSize]="26"></tc-icon> -->
              <span class="nav__text">Orders</span>
            </a>
          </li>&nbsp;&nbsp;
          <li class="nav-item col-xs-3 py-1">
            <a [routerLink]="['../', 'profile']" routerLinkActive="active" class="nav-link">
              <!-- <tc-icon [iconClass]="'icofont-user-alt-5'" [tcFontSize]="22"></tc-icon> -->
              <img src="./assets/img/profile.svg" alt="">
              <span class="nav__text">Profile</span>
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>


</div>
<!-- <app-bottommenu></app-bottommenu> -->